import { useCallback } from 'react';
import { AdminTab } from '../../types/enums';
import { useURLParams } from './useURLParams';

export function useTabPersistence() {
  const { params, updateParams, initializeFromStorage } = useURLParams({
    initialValues: {
      tab: AdminTab.OVERVIEW
    },
    paramTypes: {
      tab: 'string'
    }
  });

  // Initialize tab from localStorage if needed (for auth redirects)
  const initializeTab = useCallback(() => {
    initializeFromStorage('adminDashboardTab', 'tab');
  }, [initializeFromStorage]);

  // Change active tab
  const setActiveTab = useCallback((newTab: AdminTab) => {
    updateParams({ tab: newTab });
  }, [updateParams]);

  // Save tab to localStorage (for auth redirects)
  const saveTabForRedirect = useCallback((tab: AdminTab) => {
    localStorage.setItem('adminDashboardTab', tab);
  }, []);

  // Validate tab parameter
  const isValidTab = useCallback((tab: string): tab is AdminTab => {
    return Object.values(AdminTab).includes(tab as AdminTab);
  }, []);

  const activeTab = isValidTab(params.tab) ? params.tab : AdminTab.OVERVIEW;

  return {
    activeTab,
    setActiveTab,
    initializeTab,
    saveTabForRedirect
  };
}